module.exports = __webpack_public_path__ + "img/cryptocom.8bfc4791.png";